module.exports = __webpack_public_path__ + "media/images/workflows-empty_state-82160d74108776b6e94ec6e00d12da49.svg";